import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#1E1F1A] text-[#E7E8E2]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="h-9 w-9 rounded-lg bg-[#A7B584] grid place-items-center text-[#1E1F1A] font-semibold">
              H4
            </span>
            <div className="leading-tight">
              <div className="font-semibold">Help4Emergency</div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-[#A7B584]">KI-Leitstelle</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-[#B7B9AE] max-w-sm leading-relaxed">
            Realistisches Notruf-Training per KI-Sprachsimulation. DSGVO-konform, EU-gehostet,
            entwickelt mit und für Rettungs- und Hilfsorganisationen.
          </p>
          <p className="mt-4 inline-flex items-center gap-2 px-3 py-1 rounded-full text-[11px] font-semibold bg-[#FCEBD6] text-[#B36B15]">
            Alpha-Stand · Early Tester willkommen
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.18em] text-[#A7B584] font-semibold mb-4">Produkt</div>
          <ul className="space-y-2.5 text-sm">
            <li><a href="/#loesung" className="hover:text-white">Lösung</a></li>
            <li><a href="/#features" className="hover:text-white">Features</a></li>
            <li><a href="/#preise" className="hover:text-white">Preise</a></li>
            <li><a href="/#faq" className="hover:text-white">FAQ</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.18em] text-[#A7B584] font-semibold mb-4">Unternehmen</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/support" className="hover:text-white">Support</Link></li>
            <li><Link to="/register" className="hover:text-white">Registrieren</Link></li>
            <li><Link to="/login" className="hover:text-white">Anmelden</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.18em] text-[#A7B584] font-semibold mb-4">Vertrauen</div>
          <ul className="space-y-2.5 text-sm text-[#B7B9AE]">
            <li>DSGVO-konform</li>
            <li>EU-Hosting</li>
            <li>Evidenzbasiertes Training</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#B7B9AE]">
          <div>© {new Date().getFullYear()} help4help GmbH · Alle Rechte vorbehalten.</div>
          <div className="flex gap-5">
            <Link to="/impressum" className="hover:text-white" data-testid="footer-impressum">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white" data-testid="footer-datenschutz">Datenschutz</Link>
            <Link to="/support" className="hover:text-white">Support</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
